import React from "react";

import styles from "./EducatorSubSection.module.scss";
import { Divider, Box, Grid, Typography } from "@mui/material";
import { EmployeePosition } from "../../../api/PartnerPortalGatewayApi";
import { EducatorCard } from "../EducatorCard/EducatorCard";

interface EducatorSubSectionProps {
  title: string;
  educators: EmployeePosition[];
  changedEducatorIds?: Set<number>;
}

export const EducatorSubSection: React.FC<EducatorSubSectionProps> = ({
  title,
  educators,
  changedEducatorIds = new Set(),
}) => {
  if (educators.length === 0) {
    return null;
  }

  return (
    <Box className={styles.subSection}>
      <Box className={styles.subSectionHeader}>
        <Typography variant="overline" className={styles.subSectionTitle}>
          {title}
        </Typography>
        <Box className={styles.divider} />
      </Box>
      <Grid container spacing={2}>
        {educators.map((educator) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={educator.employeeId}>
            <EducatorCard educator={educator} isChanged={changedEducatorIds.has(educator.employeeId)} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
